module.exports = __webpack_public_path__ + "img/floorplan_3f.4eb6cac4.jpg";